/** Pure allocation helpers shared by App and DataPreview. */

/** Capture the exact portfolio state submitted to an asynchronous analysis. */
export function captureAnalysisInput({
  manualAllocation,
  selectedEtfs = [],
  weights = {},
}) {
  return {
    manualAllocation: Boolean(manualAllocation),
    selectedEtfs: selectedEtfs.map((etf) => ({ ...etf })),
    weights: { ...weights },
  };
}

/** Return the stable correlation key emitted by the backend. */
export function allocationKeyFor(row = {}) {
  return row.allocation_key || row.isin || row.ticker || "";
}

/**
 * Convert the selection screen's {ISIN: percentage} state into the
 * decimal allocation map accepted by POST /recalculate.
 *
 * ISIN matching is case-insensitive. `allocation_key` always wins over
 * legacy ISIN/ticker response shapes, which keeps same-ticker funds distinct.
 */
export function buildAllocationOverrides({
  manualAllocation,
  allocationRows = [],
  selectedEtfs = [],
  weights = {},
}) {
  if (!manualAllocation) return null;

  const selectedByIsin = new Map(
    selectedEtfs.map((etf) => [
      String(etf.isin || "").toUpperCase(),
      etf.isin,
    ]),
  );
  const selectedByTicker = new Map(
    selectedEtfs.map((etf) => [etf.ticker, etf]),
  );
  const overrides = {};

  for (const row of allocationRows) {
    const rowIsin = String(row.isin || "");
    const selectedIsin = rowIsin
      ? selectedByIsin.get(rowIsin.toUpperCase()) || rowIsin
      : selectedByTicker.get(row.ticker)?.isin;
    const key = allocationKeyFor(row);
    if (key) overrides[key] = Number(weights[selectedIsin] || 0) / 100;
  }
  return overrides;
}
